import { iappApiV1 } from '../services/api';
import { CompanyFilterOptions } from '../types/fetchCompanyFilters';

export async function fetchEmployeeFilterOptions() {
  const { data } = await iappApiV1.get<{ companies: CompanyFilterOptions[] }>(
    '/employees/filter-options'
  );

  return data;
}
